import { FC, Fragment } from "react";

export type ImageLogoLoginProps = {
  src: string;
  company: string;
};

export const ImageLogoLogin: FC<ImageLogoLoginProps> = ({ src, company }) => {
  return (
    <Fragment>
      <img
        alt={company}
        src={src}
        className="h-16 w-auto mx-auto sm:mx-0 sm:h-20 md:h-16 lg:h-12 xl:h-14"
      />
    </Fragment>
  );
};
